var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import i18next from 'i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import get from 'lodash.get';
import { useEffect, useState } from 'react';
import { initReactI18next } from 'react-i18next';
import { useQuery } from '../../hooks/useQuery';
export var EN = 'en';
export var ES = 'es';
export var FR = 'fr';
export var NAMESPACE = 'translation';
var _i18nextInstance;
var i18nextOptions = {
    fallbackLng: EN,
    debug: true,
    ns: [NAMESPACE, 'formatting'],
    defaultNS: NAMESPACE,
    partialBundledLanguages: true,
    load: 'all',
    keySeparator: '.',
    nsSeparator: null,
    interpolation: {
        escapeValue: false,
    },
};
var resources = {};
export var i18nInitOptions = __assign({ resources: resources }, i18nextOptions);
var getDefaultResources = function () { return Promise.resolve(resources); };
export var defaultResolveFormatter = function (value, formatterFullName, lng, options) {
    var _a, _b;
    var instance = getI18nInstance();
    var formatting = instance.getResource(lng, 'formatting');
    var fallbackFormatting = instance.getResource(instance.options.fallbackLng, 'formatting');
    var parentFormatting = {};
    if (lng.includes('-')) {
        parentFormatting = instance.getResource(lng.split('-')[0], 'formatting') || {};
    }
    var formatOptions = __assign(__assign(__assign(__assign({}, options), get(fallbackFormatting, formatterFullName)), get(parentFormatting, formatterFullName)), get(formatting, formatterFullName));
    var _c = formatterFullName.split('.'), formatterType = _c[0], formatterName = _c[1];
    var formatter;
    switch (formatterType) {
        case 'numbers':
            formatter = new Intl.NumberFormat(lng, formatOptions);
            break;
        case 'dates':
            formatter = new Intl.DateTimeFormat(lng, formatOptions);
            break;
        case 'customs': {
            formatter = (_b = (_a = zappy.formatters)[formatterName]) === null || _b === void 0 ? void 0 : _b.call(_a, lng, formatOptions);
            break;
        }
        default:
    }
    return (formatter === null || formatter === void 0 ? void 0 : formatter.format(value)) || value;
};
export function getI18nInstance() {
    return _i18nextInstance;
}
export function getUnitializedI18n(plugins) {
    if (plugins === void 0) { plugins = []; }
    plugins.unshift(intervalPlural);
    plugins.unshift(initReactI18next);
    _i18nextInstance = plugins.reduce(function (instance, plugin) { return instance.use(plugin); }, i18next.createInstance());
    return _i18nextInstance;
}
export function initI18n(plugins, options, getResources, resolveFormatter) {
    if (getResources === void 0) { getResources = getDefaultResources; }
    if (resolveFormatter === void 0) { resolveFormatter = defaultResolveFormatter; }
    return __awaiter(this, void 0, void 0, function () {
        var resources_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getResources()];
                case 1:
                    resources_1 = _a.sent();
                    return [2 /*return*/, getUnitializedI18n(plugins)
                            .init(__assign(__assign(__assign({}, i18nInitOptions), options), { resources: resources_1 }))
                            .then(function () {
                            var instance = getI18nInstance();
                            var originalFormat = instance.services.interpolator.format;
                            instance.services.interpolator.format = function (value, _format, lng, options) {
                                var executeFormatter = function (f) {
                                    var formatterFn = f.includes('.') ? resolveFormatter : originalFormat;
                                    return function (v, l, o) {
                                        return formatterFn(v, f, l, o);
                                    };
                                };
                                return _format === null || _format === void 0 ? void 0 : _format.split(',').reduce(function (result, formatter) { return executeFormatter(formatter.trim())(result, lng, options); }, value);
                            };
                        })];
                case 2:
                    err_1 = _a.sent();
                    console.error("initI18n: ".concat(err_1));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function gotResource(isSuccess, data) {
    return isSuccess && Boolean(data);
}
export function useTranslationsResources(getResources) {
    if (typeof getResources !== 'function') {
        throw new Error('`getResources` needs to be a function returning a Promise');
    }
    var _a = useQuery(NAMESPACE, getResources), data = _a.data, isSuccess = _a.isSuccess, props = __rest(_a, ["data", "isSuccess"]);
    var _b = useState(false), hasLoadedTranslations = _b[0], setHasLoadedTranslations = _b[1];
    useEffect(function () {
        if (!gotResource(isSuccess, data))
            return;
        Object.keys(data).forEach(function (lang, index) {
            getI18nInstance().addResourceBundle(lang, NAMESPACE, data[lang][NAMESPACE]);
            if (index === Object.keys(data).length - 1) {
                setHasLoadedTranslations(true);
            }
        });
    }, [data, isSuccess]);
    return __assign({ data: data, isSuccess: isSuccess && hasLoadedTranslations }, props);
}
